import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
// import { Analysis, Project } from 'src/app/instant-analysis/models/map-config';
import { TimespanService } from 'src/app/instant-analysis/services/timespan/timespan.service';
import { SaveAnalysisResponse } from 'src/app/mainmenu/models/save-analysis-response';
import { environment } from 'src/environments/environment';
import { Analise, Projeto } from '../models/analise';
import { StationMissingData } from '../models/missing-data-station';

/**
 * Serviçço de CRUD dos projetos e análises.
 */
@Injectable({
  providedIn: 'root'
})
export class AppUserService {

  /**
   * Construtor.
   * @param http serviço para chamadas http get e post.
   */
  constructor(protected http: HttpClient) { }

  /** URL do endpoint da busca por todos os projetos */
  urlProjectGet = `${environment.serverBaseUrl}/projeto/getAll`;

  /** URL do endpoint de inserção de projeto */
  urlProjectAdd = `${environment.serverBaseUrl}/projeto/add`;

  /** URL do endpoint de exclusão de projeto */
  urlProjectRemove = `${environment.serverBaseUrl}/projeto/remove`;

  /** URL do endpoint de edição de projeto */
  urlProjectEdit = `${environment.serverBaseUrl}/projeto/edit`;

  /** URL do endpoint de busca de todas as análises de um projeto */
  urlAnalysisGet = `${environment.serverBaseUrl}/analise/getAll`;

  /** URL do endpoint de inserção de análise */
  urlAnalysisAdd = `${environment.serverBaseUrl}/analise/add`;

  /** URL do endpoint de exclusão de análise */
  urlAnalysisRemove = `${environment.serverBaseUrl}/analise/remove`;

  /** URL do endpoint de edição de análise */
  urlAnalysisEdit = `${environment.serverBaseUrl}/analise/edit`;

  /** URL do endpoint da carga de dados de chuva de um arquivo csv */
  urlMissingData = `${environment.serverBaseUrl}/chuva/missingData`;

  /**
   * Busca todos os projetos relacionados ao usuário.
   * @param user_id ID do usuário conectado
   * @returns observable da busca de projetos
   */
  getAllProjectsFromUser(user_id:number): Observable<Projeto[]>{    //observa assincronamente
    return this.http.get<Projeto[]>(this.urlProjectGet,{params:{user_id:user_id}}).pipe(
      tap((_) => console.log("Got all Project Data")));
  }

  /**
   * Insere projeto
   * @param projeto projeto a ser inserido
   * @returns Observable da inserção do projeto
   */
  addProject(projeto: Projeto): Observable<SaveAnalysisResponse>{
    return this.http.post<any>(this.urlProjectAdd, projeto).pipe(
      tap((_) => console.log("Added new Project")));
  }

  /**
   * Exclui projeto
   * @param project_id ID do projeto a ser excluído 
   * @returns Observable da exclusão do projeto
   */
  removeProject(project_id:number): Observable<any>{
    return this.http.get<any>(this.urlProjectRemove,{params:{project_id:project_id}}).pipe(
      tap((_) => console.log("Removed Project")));
  }

  /**
   * Edita um projeto
   * @param projeto projeto a ser editado
   * @returns Observable da edição do projeto
   */
  editProject(projeto:Projeto): Observable<any>{
    return this.http.get<any>(this.urlProjectEdit,{params:{project_id:projeto.id,nome:projeto.nome}}).pipe(
      tap((_) => console.log("Edited Project")));
  }

  /**
   * Busca as análises relacionadas a um projeto
   * @param project_id ID do projeto cujas análises serão buscadas.
   * @returns Observable da busca das análises
   */
  getAllAnalysisFromProject(project_id:number): Observable<Analise[]>{    //observa assincronamente
    return this.http.get<Analise[]>(this.urlAnalysisGet,{params:{project_id:project_id}}).pipe(
      tap((_) => console.log("Got all Analysis Data")));
  }

  /**
   * Insere análise relacionada a um projeto
   * @param analise análise a ser inserida
   * @returns Observable da inserção da análise
   */
  addAnalysisToProject(analise: Analise): Observable<any>{

    return this.http.post<any>(this.urlAnalysisAdd, analise).pipe(
      tap((_) => console.log("Added new Analysis"))
    );
  }

  /**
   * Exclui uma análise
   * @param analysis_id ID da análise a ser excluída 
   * @returns Observable da análise a ser excluída
   */
  removeAnalysisFromProject(analysis_id:number): Observable<any>{
    return this.http.get<any>(this.urlAnalysisRemove,{params:{analysis_id:analysis_id}}).pipe(
      tap((_) => console.log("Removed Analysis")));
  }

  /**
   * Edita a análise
   * @param analise análise a ser editada
   * @returns 
   */
  editAnalysis(analise: Analise): Observable<any>{

    return this.http.post<any>(this.urlAnalysisEdit, analise).pipe(
      tap((_) => console.log("Edited Analysis")));
  }

  getMissingDataPerStation(): Observable<any> {
    return this.http.get<StationMissingData>(this.urlMissingData);
  }

}
